import { checkUrl } from '../../url'

export type FetchOriginCheck =
	{ ok: true; origin: string } | { ok: false; reason: 'empty' | 'invalid' | 'same-as-site' }

/**
 * Validates the address we'd fetch a folder site from. Besides being a real
 * address it must not be the site's own domain: in folder mode that domain
 * points at us, so fetching it would ask ourselves for every page. `www.`
 * counts as the same host — it almost always follows the apex.
 */
export function checkFetchOrigin(input: string, siteOrigin: string): FetchOriginCheck {
	if (!input.trim()) {
		return { ok: false, reason: 'empty' }
	}
	const check = checkUrl(input)
	if (!check.ok) {
		return { ok: false, reason: 'invalid' }
	}
	if (bareHost(check.origin) === bareHost(siteOrigin)) {
		return { ok: false, reason: 'same-as-site' }
	}
	return { ok: true, origin: check.origin }
}

export function bareHost(url: string): string {
	try {
		return new URL(url).hostname.replace(/^www\./i, '').toLowerCase()
	} catch {
		return ''
	}
}
